import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  BulletedListStyled,
  LinkStyled,
} from './styles';

const bulletedListConfigCustomerPrivacyNotices = [
  {
    bulletText: <>
      <Link
        id='privacy-notices-nm-link'
        variant='primaryDeemphasize'
        linkUrl='https://www.northwesternmutual.com/customer-privacy-notice/#nm'>
        The Northwestern Mutual Life Insurance Company
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-nltc-link'
        variant='primaryDeemphasize'
        linkUrl='https://www.northwesternmutual.com/customer-privacy-notice/#nltc'>
        Northwestern Long Term Care Insurance Company
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-nm-and-nmwmc-link'
        variant='primaryDeemphasize'
        linkUrl='https://www.northwesternmutual.com/customer-privacy-notice/#nmisAndnmwmc'>
        Northwestern Mutual Investment Services, LLC &#40;NMIS&#41; &#38; Northwestern Mutual Wealth Management Company&#40;NMWMC&#41;
      </Link>
    </>,
  },
];

const bulletedListConfigCaliforniaPrivacyNotices = [
  {
    bulletText: <>
      <Link
        id='privacy-notices-ccpa-collection-link'
        variant='primaryDeemphasize'
        linkUrl='/ccpa-notice-at-collection/'>
        California Notice at Collection
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-ccpa-privacy-link'
        variant='primaryDeemphasize'
        linkUrl='/ccpa-privacy-policy/'>
        California Consumer Privacy Policy
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-california-agents-policy-notice-link'
        variant='primaryDeemphasize'
        linkUrl='/california-agents-policy-notice/'>
        California Sales Force Privacy Policy
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-california-workforce-policy-notice-link'
        variant='primaryDeemphasize'
        linkUrl='/california-workforce-policy-notice/'>
        California Workforce Privacy Policy
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='supplemental-notice-of-insurance-information-practices'
        variant='primaryDeemphasize'
        linkUrl='/supplemental-notice-of-insurance-information-practices/'>
        Supplemental Notice of Insurance Information Practices
      </Link>
    </>,
  },
];

const bulletedListConfigHipaaPrivacyNotice = [
  {
    bulletText: <>
      <Link
        id='privacy-notices-hipaa-privacy-link'
        variant='primaryDeemphasize'
        linkUrl='/hipaa-privacy-notice/'>
        Notice of Privacy Practices for Protected Health Information of Northwestern Life Insurance Company
      </Link>
    </>,
  },
  {
    bulletText: <>
      <Link
        id='privacy-notices-hipaa-privacy-ltc-link'
        variant='primaryDeemphasize'
        linkUrl='/hipaa-privacy-notice-ltc/'>
        Notice of Privacy Practices for Protected Health Information of Northwestern Long Term Care Insurance Company
      </Link>
    </>,
  },
];

export default () => (
  <SectionContainer
    id='privacy-notices'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'
          align='center'>
          Our Commitment <WidowBlock>to Privacy</WidowBlock>
        </Typography>
        <Typography nextElement='typography'>
          The Northwestern Mutual Family of Companies&#42; is committed to protecting the confidentiality of your personal information.
          We respect your privacy rights and choices, which may vary based on your interactions with us or your relationship to us.
          Please review the policies below to learn more.
        </Typography>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Privacy Notices
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Online Privacy Statement
        </Typography>
        <Typography nextElement='typography'>
          This statement applies when you visit any of the websites or mobile applications owned or operated by the Northwestern Mutual Family of Companies.
        </Typography>
        <LinkStyled
          id='privacy-notices-online-privacy-link'
          variant='primaryDeemphasize'
          linkUrl='/online-privacy-statement/'>
          Online Privacy Statement
        </LinkStyled>
        <Typography
          component='h3'
          nextElement='typography'>
          Customer Privacy Notices
        </Typography>
        <Typography nextElement='typography'>
          These notices apply when you are a prospect or client of our Northwestern Mutual Family of Companies.
        </Typography>
        <BulletedListStyled bulletedListData={bulletedListConfigCustomerPrivacyNotices} />
        <Typography
          component='h3'
          nextElement='typography'>
          California Privacy Policies
        </Typography>
        <Typography nextElement='typography'>
          These policies and notice apply when you are a California consumer.
        </Typography>
        <BulletedListStyled bulletedListData={bulletedListConfigCaliforniaPrivacyNotices} />
        <Typography
          component='h3'
          nextElement='typography'>
          HIPAA Privacy Notices
        </Typography>
        <Typography nextElement='typography'>
          These notices apply when you are customer of Northwestern Mutual Long Term Care Insurance Company or purchase life
          insurance with a long&#45;term care benefit rider.
        </Typography>
        <BulletedListStyled bulletedListData={bulletedListConfigHipaaPrivacyNotice} />
        <Typography disableBottomPadding>
          &#42;The Northwestern Mutual Family of Companies means The Northwestern Mutual Life Insurance Company, Northwestern
          Long Term Care Insurance Company, Northwestern Mutual Investment Services Company, LLC, Northwestern Mutual Wealth
          Management Company, and the network offices of our Sales Force. Our Sales Force includes the people who sell our
          products and services, along with their staffs.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
